import React from 'react';
import { Box, useTheme } from '@mui/material';
import { RADIUS } from '../../theme/tokens';

/**
 * SurfaceCard
 * A clean card surface using the design token system.
 * Optionally interactive (hover shadow lift and pointer cursor).
 *
 * @param {number}                      [padding=2]
 * @param {'sm'|'md'|'lg'|'xl'|'pill'} [radius='lg']
 * @param {'xs'|'sm'|'md'|'lg'}        [elevation='sm']
 * @param {boolean}                     [interactive=false]
 * @param {function}                    [onClick]
 * @param {object}                      [sx]
 * @param {ReactNode}                   children
 */
function SurfaceCard({
  padding = 2,
  radius = 'md',
  elevation = 'sm',
  interactive = false,
  onClick,
  sx = {},
  children,
  ...rest
}) {
  const theme = useTheme();

  const borderRadius = RADIUS[radius] ?? RADIUS.lg;
  const shadow = theme.shadowsExt?.[elevation];

  const interactiveStyles = interactive
    ? {
        cursor: 'pointer',
        transition: 'box-shadow 0.18s ease, transform 0.18s ease',
        '&:hover': {
          boxShadow: theme.shadowsExt?.md,
          transform: 'translateY(-2px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      }
    : {};

  return (
    <Box
      onClick={onClick}
      sx={{
        bgcolor: 'background.paper',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius,
        boxShadow: shadow,
        p: padding,
        ...interactiveStyles,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default SurfaceCard;
